import React from 'react';
import autobind from 'autobind-decorator';

import {PermissionCheckerEnhance} from "../../Common/Enhancements";
import {service as ProjectStatusService} from "../../../Services/ProjectStatusService";
import {GenericModelViewerOldBase} from "../../Common/GenericModelViewerOld";


@PermissionCheckerEnhance
export class ProjectModelViewer extends GenericModelViewerOldBase {
    constructor() {
        super();

        this.setInitialState({
            statuses: []
        });
    }

    componentDidMount() {
        ProjectStatusService.Get()
            .then((x) => {
                this.setState({ statuses: x.result });
            });
    }

    @autobind
    getAbandonedId() {
        let abandoned = this.state.statuses.find((x) => x.shortName === "abandoned");

        if(abandoned) {
            return abandoned.projectStatusId;
        }

        return null;
    }

    @autobind
    getFieldDefs(includeHidden = false) {
        let ret = [];
        let result = super.getFieldDefs(includeHidden);

        result.forEach((group) => {
            if (group.key === "General") {
                if (!this.props.Data.projectStatusId || this.props.Data.projectStatusId != this.getAbandonedId()) {
                    group.value.forEach((field) => {
                        if(field.key === "projectStatusNote") {
                            let index = group.value.indexOf(field);

                            if(index > -1) {
                                group.value.splice(index, 1);
                            }
                        }
                    });
                }
            }

            ret.push(group);
        });

        return ret;
    }
}
